
export default ({ smartCrossLinks }) => {
  return smartCrossLinks?.globalVariables?.br_related_rid || "";
};
